import "./PartnerDashboard.scss";
import { Route, Routes } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetUserProfile } from "../../API/endpoints/User";
import BrandNavBar from "../components/header/BrandNavBar";
import Dashboard from "./brand/Dashboard";
import Brands from "./brand/Brands";
import Intelligence from "./brand/Intelligence";
import Discovery from "./brand/Discovery";
import Trades from "./brand/Trades";
import { BrandTabsContextProvider } from "../Organization/contexts/BrandTabsContext";
import PartnerProfile from "./brand/PartnerProfile";
import { USER_TYPE_PARTNER } from "../../constants/constants";
import { GetPartnerTodosByUserID } from "../../API/endpoints/Todos";

const NewPartnerDashboard = () => {

  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});


  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      GetUserProfile(userID).then((res) => {
        setUserProfile(res?.data);
      }).catch((err) => {
        console.log("err", err);

      })
    }

  }, [userID])

  return (
    <Container fluid className="partner-dashboard !h-[100%] ">
      <Row>
        <Col className="p-0 col-right">
          <BrandNavBar userProfile={userProfile} />
          <Routes>
            <Route path="/">
              <Route index element={<Dashboard userProfile={userProfile} />} />
              <Route
                path="intelligence"
                element={<Intelligence userProfile={userProfile} />}
              />
              <Route
                path="discovery"
                element={<Discovery userProfile={userProfile} />}
              />
              <Route
                path="trades"
                element={<Trades />}
              />
              <Route
                path="profile"
                element={<PartnerProfile userProfile={userProfile} />}
              />
            </Route>

          </Routes>
        </Col>
      </Row>
    </Container>
  );
};

export default NewPartnerDashboard;
